import { CacheableDataObject } from 'models/CacheableDataObject.jsx';

class ConnectedField extends CacheableDataObject {

	pullFieldFromPlayer(player) {
		let data = player.connected_fields[this.type];
		if(data) {
			const { primary_value } = data;
			if(this.isEditable() && (
				primary_value === '' ||
				primary_value === null ||
				primary_value === undefined
			)
			) {
				return null;
			}
			return data;
		}
		return null;
	}

	hasClickableLink() {
		return !!this.link;
	}

	isNormalDisplayed() {
		return this.input == 2 || this.input == 3;
	}

	hasConnectUrl() {
		return this.input == 1 && this.connect_url;
	}

	isEditable() {
		return this.input === 2 || this.input === 3;
	}

}

export { ConnectedField };